import { render, staticRenderFns } from "./OrderFeeTrend.vue?vue&type=template&id=039e7dee&scoped=true"
import script from "./OrderFeeTrend.vue?vue&type=script&lang=js"
export * from "./OrderFeeTrend.vue?vue&type=script&lang=js"
import style0 from "./OrderFeeTrend.vue?vue&type=style&index=0&id=039e7dee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039e7dee",
  null
  
)

export default component.exports